/* eslint-disable */
import { 
   
    orangeThemeLight
} from '../theme/theme'


export const themeData = {
    theme: orangeThemeLight
}


